module.exports = __webpack_public_path__ + "14d00da.ttf";